import React from "react";
import { classNames } from "./utils";

interface CallButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
  variant?: "green" | "blue" | "red";
  title?: string;
}

export function CallButton({
  onClick,
  disabled = false,
  label = "Call",
  variant = "green",
  title,
}: CallButtonProps) {
  const bgColor = variant === "green" 
    ? "bg-green-500 text-white hover:bg-green-600"
    : variant === "red"
    ? "bg-red-500 text-white hover:bg-red-600"
    : "bg-blue-500 text-white hover:bg-blue-600";

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        "flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium shadow-sm transition",
        disabled
          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
          : bgColor
      )}
      title={title}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
      </svg>
      {label}
    </button>
  );
}

